import { getCachedAPIResponse } from "../apiCaching/apiWrapper";
import { apiConfig } from "../config/apiConfig";
import { isValidCAPostalCode } from "../nbly-brand/helper_functions";
import { getSessionAndCorrelationID } from "../util/getSessionCorrelationId";

interface SearchTermData {
    serviceId: string;
    searchTerm: string;
}

 export async function fetchSearchTerms(serviceName: string, zipCode: string): Promise<SearchTermData[]> {
    const countryId = isValidCAPostalCode(zipCode) ? 2 : 1;
    const sessionData = getSessionAndCorrelationID();
   
    if(!zipCode || !serviceName){
        return [];
    }
    let formattedZip = zipCode;
    if(isValidCAPostalCode(zipCode) && !formattedZip.includes(' ')){
        formattedZip = formattedZip.slice(0, 3) + ' ' + formattedZip.slice(3);
    }
    const url = `${apiConfig.ServiceSearchTermAPI}&search_term=${encodeURIComponent(serviceName)}&country_id=${countryId}&postal_code=${formattedZip}&correlationId=${sessionData.correlationID}&sessionId=${sessionData.sessionID}`;
    
    return await getCachedAPIResponse(url, 60);
}
